import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { Grid, Typography } from '@material-ui/core';
import { AccordionButton, useAccordionItemContext } from '@reach/accordion';

import appDateTime from '@edf-pkg/app-date-time';

import useStyles from './styles';

import { FontAwesomeIcon } from '$common/fontawesome-pro/react-fontawesome';

const Header = (props) => {
    const { title, authors, date, url } = props;

    const { isExpanded } = useAccordionItemContext();

    const classes = useStyles(props);

    return (
        <div className={clsx(classes.root, { [classes.expanded]: isExpanded })}>
            <Grid container justify="space-between" alignItems="center" spacing={1}>
                <Grid container item xs={12} md={8} direction="column">
                    <Grid item>
                        <Typography className={classes.title} component="a" variant="h6" href={url} target="_blank">
                            {title}
                        </Typography>
                    </Grid>
                    <Grid item>
                        <Typography variant="caption" className={classes.subtitle}>
                            {authors.map((author) => `${author.firstName} ${author.lastName}`).join(', ')}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} md={4} className={classes.sideContentWrapper}>
                    <Grid item>
                        <Typography variant="caption" className={classes.date}>
                            {appDateTime(date).format(appDateTime.FORMATS.DATE_HUMAN_READABLE)}
                        </Typography>
                    </Grid>
                    <Grid item className={classes.buttonWrapper}>
                        <AccordionButton>
                            <Typography variant="caption" className={classes.buttonText}>
                                {isExpanded ? 'Collapse' : 'Read More'}
                            </Typography>
                            <div className={classes.buttonIconWrapper}>
                                <FontAwesomeIcon
                                    icon={['fad', 'angle-right']}
                                    className={clsx(classes.buttonIcon, { [classes.buttonIconUp]: isExpanded })}
                                />
                            </div>
                        </AccordionButton>
                    </Grid>
                </Grid>
            </Grid>
        </div>
    );
};

Header.propTypes = {
    title: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired,
    authors: PropTypes.array.isRequired,
    url: PropTypes.string.isRequired,
};

export default Header;
